import Vue from 'vue'
import cnLang from './cnLang'
import enLang from './enLang'
import getParams from '../utils/getParams'
let {platformType, platformUserType, showEnglish} = getParams()
platformType = Number(platformType) || 0
platformUserType = Number(platformUserType) || 3

// 汉语吧or说客的老师 展示英文
let isShowEnglish = Boolean(showEnglish || platformType === 2 || (platformType === 0 && platformUserType === 2))

function setTheme (platformInfo) {
  let themeItem = {
    ...platformInfo,
    logoUrl: platformInfo.logo ? platformInfo.logo.split('?Expires=')[0] : '',
    platformName: isShowEnglish ? platformInfo.platformEnglishName : platformInfo.platformShortName,
    kfImgUrl: platformInfo.head ? platformInfo.head.split('?Expires=')[0] : ''
  }
  let {topicColor, platformName} = themeItem
  // 设置主题色
  document.documentElement.style.setProperty('--main-color', topicColor)
  Vue.prototype.$lang = isShowEnglish ? enLang : cnLang
  // 设置网站标题
  document.title = platformName
  Vue.prototype.$isShowEnglish = isShowEnglish
  Vue.prototype.$theme = themeItem
}

export default setTheme



// WEBPACK FOOTER //
// ./src/theme/setTheme.js